export default __webpack_public_path__ + "static/media/test.1ff98bb3.jpg";